import React from 'react';
import { ItemCreation } from '~/Components';
import { useEventEdit } from './hooks';
import { useTranslation } from 'react-i18next';
import { PrivateLayout } from '~/Layout/PrivateLayout';
import { ExtendedEvent } from './ExtendedEvent.model';
import { useMediaQuery, useTheme } from '@mui/material';
import { useEventValidationSchema } from './hooks/useEventValidationSchema';

export const EventEdit = () => {
  const {
    title,
    eventName,
    initialValues,
    eventGroupName,
    validate,
    isLoading,
    listItems,
    headers,
    onSave,
    error,
  } = useEventEdit();
  const { t } = useTranslation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('md'));
  const { editValidationSchema } = useEventValidationSchema();

  const eventItemCreationTitle =
    eventName || eventGroupName ? `${t('app.editing')} ${eventName || eventGroupName}` : title;
  const pageTitle = mobile ? title : eventItemCreationTitle;

  return (
    <PrivateLayout
      title={pageTitle}
      actionName={t('app.save')}
      onActionTaken={onSave}
      actionDisabled={isLoading}
      cancelInsteadOfBack
    >
      <ItemCreation<ExtendedEvent>
        listItems={listItems}
        headers={headers}
        onSave={onSave}
        initialValues={initialValues}
        validate={validate}
        networkError={error}
        isLoading={isLoading}
        validationSchema={editValidationSchema}
      />
    </PrivateLayout>
  );
};
